
import React from 'react';

function Footer() {
  return (
    <div className="w-full flex flex-wrap items-center justify-center text-xs sm:text-sm">

      <i className="fa fa-copyright" style={{ fontSize: 10 }}></i>

      <div className='text-[10px]'>Powered by</div>

      <img
        style={{ width: "20px", margin: "0 3px" }}
        src={require("../Assets/new_logo.png")}
        alt="logo"
      />

      <div className='text-[10px]'>
        SuperManager
      </div>

    </div>
  );
}

export default Footer;
